<div class="position-relative">
  <div *ngIf="loading" class="text-center py-3">
    <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <ag-grid-angular
    *ngIf="tickets.length > 0"
    class="ag-theme-alpine"
    [rowData]="tickets"
    [columnDefs]="columnDefs"
    [defaultColDef]="defaultColDef"
    [domLayout]="'autoHeight'"
    (gridReady)="onGridReady($event)"
    [rowHeight]="42">
  </ag-grid-angular>

  <div *ngIf="!loading && tickets.length === 0" class="text-center text-muted py-4">
    No auto-closed tickets found.
  </div>

  <div *ngIf="tickets.length > 0 && tickets.length >= limit" class="text-center py-2">
    <button class="btn btn-sm btn-outline-primary" (click)="loadMore()" [disabled]="loading">
      Load More
    </button>
  </div>
</div>

<!-- Ticket Detail Modal -->
<div *ngIf="showDetailModal" class="modal d-block" tabindex="-1" style="background: rgba(0,0,0,0.5)">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Ticket #{{ selectedTicketId }}</h5>
        <button type="button" class="btn-close" (click)="closeDetailModal()"></button>
      </div>
      <div class="modal-body">
        <app-ticket-detail *ngIf="selectedTicketId" [ticketId]="selectedTicketId"></app-ticket-detail>
      </div>
    </div>
  </div>
</div>
